import React from 'react';
import { useNavigate } from 'react-router-dom';
import { List, Plus } from 'lucide-react';
import EmptyState from '../../../../components/common/EmptyState';

export default function EditEmptyState() {
  const navigate = useNavigate();
  return (
    <EmptyState
      icon={<List size={48} strokeWidth={1.75} />}
      title="No accounts to edit yet"
      description="Your Chart of accounts is empty. Add an account to start building it, or go back and pick a template."
      action={{
        label: 'Add first account',
        onClick: () => navigate('/accounting/chart-of-accounts/create-multiple'),
        icon: <Plus size={16} />,
      }}
      secondaryAction={{
        label: 'Back to Chart of accounts',
        onClick: () => navigate('/accounting/chart-of-accounts'),
      }}
    />
  );
}